import { APIRoutes } from "../../../../../constants";
import { RequestServer } from "../../../../../utils/services";
import { ThandleInviteSubmit } from "./type";

export const sendInviteFields = [{ label: "Email", value: "email" }];

export const yesNoOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

type LabelValue = { label: string; value: string };

export type DefaultValues = {
  send_invite: LabelValue | string | null;
  share_agenda: string | null;
};

export const defaultValues = {
  send_invite: {
    email: true,
    whatsapp: false
  },
  share_agenda: null,
  selected_agendas: [],
};

export const getOrdinalSuffix = (n: number) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

export const handleInviteSubmit = async ({setLoading, pe_id, sendInviteValue, shareAgendaValue, selectedAgendasValue, handleClose, enqueueSnackbar, refetch}: ThandleInviteSubmit) => {
    try {
      setLoading(true);
      // Validation
      if (!pe_id) {
        enqueueSnackbar("ID not found", {
          variant: "error", autoHideDuration: 2000,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
        });
        return;
      }
      

        const selectedMethods =
          sendInviteValue && typeof sendInviteValue === 'object' && !Array.isArray(sendInviteValue)
            ? Object.entries(sendInviteValue)
              .filter(([_, value]) => !!value)
              .map(([key]) => key.toUpperCase())
    : [];
      if (selectedMethods.length === 0) {
        enqueueSnackbar("Please select at least one invite method", {
          variant: "warning",
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
        });
        return;
      }


      if (shareAgendaValue && selectedAgendasValue.length === 0) {
        enqueueSnackbar("Please select at least one agenda", {
          variant: "warning",
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
        });
        return;
      }

      const formData: {
        action: string;
        id: number | null | undefined;
        invite_methods: string[];
        share_agenda: boolean;
        agenda_ids?: number[];
      } = {
        action: "Invite",
        id: pe_id,
        invite_methods: selectedMethods,
        share_agenda: shareAgendaValue || false,
        agenda_ids: [],
      };

      if (shareAgendaValue) {
        if (selectedAgendasValue.length === 0) {
          enqueueSnackbar("Please select at least one agenda", {
            variant: "warning",
            autoHideDuration: 2000,
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
          });
          return;
        }
        formData.agenda_ids = selectedAgendasValue;
      }else{
        delete formData.agenda_ids;
      }

      const res = await RequestServer(
        APIRoutes.peMappingExpertInvite,
        "PATCH",
        formData,
      );

      if (res.success) {
        enqueueSnackbar("Expert invited successfully", { variant: "success" });
        handleClose();
      } else {
        enqueueSnackbar(res.message || "Failed to invite expert", { variant: "error" });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("An error occurred while inviting expert", { variant: "error" });
    } finally {
      refetch();
      setLoading(false);
    }
  };

export const agendaFilterOptions = [
    { label: "All", value: "all" },
    { label: "Responded By Expert", value: "responded-by-expert" },
    { label: "Responded By Admin", value: "responded-by-admin" },
    { label: "Declined", value: "declined" },
    { label: 'New Agenda', value: 'new-agenda'},
    { label: 'Shared', value: 'shared'},
  ];